import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import type { KnitStep } from "@/content";

type StepListProps = {
  readonly label: string;
  readonly steps: readonly KnitStep[];
  readonly active: number;
  readonly onSelect: (index: number) => void;
};

// The steps an animation beside it runs through: the one it is at marked, each a button to it. Only
// beside it: stacked under it on a phone, the animation runs on its own.
export const StepList = ({ label, steps, active, onSelect }: StepListProps) => (
  <Box as="nav" display={{ base: "none", lg: "block" }} aria-label={label}>
    <Grid as="ol" borderTop="1px solid" borderColor="line.hairline">
      {steps.map((entry, index) => {
        const isActive = index === active;

        return (
          <Box as="li" key={entry.id} borderBottom="1px solid" borderColor="line.hairline">
            <Grid
              as="button"
              type="button"
              aria-current={isActive ? "step" : undefined}
              onClick={() => onSelect(index)}
              w="100%"
              templateColumns="auto minmax(0, 1fr)"
              columnGap="clamp(14px, 1.6vw, 22px)"
              py="clamp(14px, 1.6vw, 20px)"
              textAlign="left"
              data-group
            >
              <Box
                as="span"
                fontSize="small"
                color={isActive ? "brand.600" : "warm.600"}
                transitionProperty="color"
                transitionDuration="0.3s"
                transitionTimingFunction="brand"
                sx={{ fontVariantNumeric: "tabular-nums" }}
              >
                {String(index + 1).padStart(2, "0")}
              </Box>
              <Box as="span" display="block" minW={0}>
                <Heading
                  as="span"
                  display="block"
                  fontSize="clamp(1.0625rem, 1.35vw, 1.375rem)"
                  lineHeight={1}
                  color={isActive ? "ink.DEFAULT" : "warm.600"}
                  transitionProperty="color"
                  transitionDuration="0.3s"
                  transitionTimingFunction="brand"
                  _groupHover={{ color: "ink.DEFAULT" }}
                >
                  {entry.title}
                </Heading>
                <Text as="span" display="block" mt="8px" variant="body" fontSize="small" lineHeight={1.45}>
                  {entry.body}
                </Text>
              </Box>
            </Grid>
          </Box>
        );
      })}
    </Grid>
  </Box>
);
